import { useScroll } from "framer-motion";
import React, { useContext, useEffect, useRef, useState } from "react";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { MyBookPanditCategoryAPI } from "../../ApiServices/BookPanditAPI/BookPanditAPI";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { Navigate, useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel3";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { TempleLookUpList } from "../../ApiServices/Temple/TempleApi";
import { t } from "i18next";
import { GetProductCategoryLookupList } from "../../ApiServices/EStore/EStoreApi";
const TrendingStoreProductsCategory = ({ Show, moduleName }) => {
    const [categories, setCategories] = useState([]);
    const user_id = localStorage.getItem("userID");
    const carouselRef = useRef(); // Step 1
    const { setLoader, loader, pujaStatus, setPujaStatus, selectedLanguageID } =
        useContext(LoaderContext);
    const navigate = useNavigate();
    useEffect(() => {
        if (moduleName === 'eStore') {
            TrendingProductCategories();
        } else if (moduleName === 'prasad') {
            TrendingPrasadCategories();
        }

    }, []);


    const TrendingProductCategories = async () => {
        setLoader(true);

        try {
            const response = await GetProductCategoryLookupList({
                applangID: (selectedLanguageID),

            });

            if (response?.statusCode === 200) {
                setLoader(false);
                const list = response?.responseData?.data || []
                const FilteredList = list?.filter((value, index) => value?.productCount > 0)
                setCategories(FilteredList);

            }
        } catch (error) {
            setLoader(false);
            console.log(error);
        }



    };

    const TrendingPrasadCategories = async () => {
        setLoader(true);
        try {
            let response = await TempleLookUpList(); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);

                const list = response?.DATA || [];

                const mappedList = list.filter((item) => item.TempleCount > 0).map((item) => ({
                    CAT_ID: item.TempleID,
                    CAT_NAME: item.TempleName
                }));
                setCategories(mappedList);
            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };


    const scrollHorizontally = (direction) => {
        if (!carouselRef.current) return;
        if (direction === "left") {
            carouselRef.current.prev(); // Go to previous slide
        } else {
            carouselRef.current.next(); // Go to next slide
        }
    };

    const handleCatClick = (value) => {
        sessionStorage.setItem("selectedCatId", value?.productCatKeyID);
        if (moduleName === 'eStore') {
            navigate(`/my-store`, {
                state: { selectedCat: value?.productCatKeyID },
            });
        } else {
            navigate(`/prasad-list`, {
                state: { selectedCat: value?.productCatKeyID },
            });
        }

    };
    let options = {}
    if (categories?.length < 5) {
        options = {
            items: 4,
            loop: false,
            margin: 30, // ⬅️ Increased spacing between items

            autoplay: false,
            autoplayTimeout: 3000,
            autoplaySpeed: 1000,
            autoplayHoverPause: false,
            smartSpeed: 800,
            dots: false,
            nav: false,
            responsive: {
                0: {
                    items: 2,
                },
                768: {
                    items: 4,
                },
                1024: {
                    items: 5,
                },
            },
        };
    } else {
        options = {
            items: 4,
            loop: false,
            margin: 30, // ⬅️ Increased spacing between items
            autoWidth: true,
            autoplay: false,
            autoplayTimeout: 3000,
            autoplaySpeed: 1000,
            autoplayHoverPause: false,
            smartSpeed: 800,
            dots: false,
            nav: false,
            responsive: {
                0: {
                    items: 2,
                },
                768: {
                    items: 4,
                },
                1024: {
                    items: 5,
                },
            },
        };
    }


    return (
        <>
            <section class="product-circle-section" style={{ background: "white" }}>

                <div class="section-title text-center">
                    <h6 class="sec-title__tagline bw-split-in-right">
                        <img className="tagline-img" src={placeholderImg} alt="" />
                        {t("Product Categories")}
                    </h6>
                    <h3 class="sec-title__title bw-split-in-left">
                        {" "}
                        {moduleName === "eStore" ? t("Product Categories") : t("Prasad Categories")}
                    </h3>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        overflow: "visible",
                        marginBottom: "20px"

                    }}
                >
                    {categories?.length > 3 && (
                        <button
                            className="carousel-arrow d-none-mobile"
                            onClick={() => scrollHorizontally("left")}
                            style={{
                                zIndex: 2,
                                border: "none",
                                marginRight: "10px",
                                background: "none",
                                cursor: "pointer",
                            }}
                        >
                            <i className="fa-solid fa-chevron-left"></i>
                        </button>
                    )}

                    <div style={{ width: "95%" }}>
                        <OwlCarousel className="owl-theme" {...options} ref={carouselRef}>
                            {categories?.map((val, index) => (
                                <div
                                    className="product-circle-item service-one__item trendingCatHover"
                                    style={{
                                        margin: 0,
                                        padding: 0,
                                        textAlign: "center",
                                        cursor: "pointer",
                                        backgroundColor: 'transparent',
                                        height: '13em'
                                    }}
                                    onClick={() => handleCatClick(val)}
                                >
                                    <div className="service-one__item__icon">
                                        <img src={val?.PUJACAT_ICON || placeholderImg} alt="careox" height={50} width={50} style={{ objectFit: "contain" }} />
                                    </div>
                                    <p
                                        className="product-label"
                                        style={{
                                            whiteSpace: "normal",
                                            wordBreak: "break-word",
                                            maxWidth: "100px",
                                            margin: "0 auto",
                                        }}
                                    >
                                        {val?.productCategoryName}
                                    </p>
                                </div>
                            ))}
                        </OwlCarousel>
                    </div>

                    {categories?.length > 3 && (
                        <button
                            className="carousel-arrow d-none-mobile"
                            onClick={() => scrollHorizontally("right")}
                            style={{
                                zIndex: 2,
                                border: "none",
                                marginLeft: "10px",
                                background: "none",
                                cursor: "pointer",
                            }}
                        >
                            <i className="fa-solid fa-chevron-right"></i>
                        </button>
                    )}
                </div>

            </section>
        </>
    );
};

export default TrendingStoreProductsCategory;
